module.exports = __webpack_public_path__ + "img/bankbutton2.94c861ff.jpg";